export const NAV_ITEMS = [
  { id: "home",      label: "Home" },
  { id: "product",   label: "Product" },
  { id: "technical", label: "Technical Data" },
  { id: "about",     label: "About Us" },
  { id: "contact",   label: "Contact" },
];
